module.exports = __webpack_public_path__ + "img/37d262c.png";